import { BatteryChecklistItem } from "@Light/services/lightTypes";

export type ChecklistDisplayItem = {
  field: string;
  label: string;
  completed: boolean;
};

/**
 * Transforms backend checklist items into display-friendly format with
 * appropriate labels and completion status.
 */
export function createChecklistDisplayItems(
  backendChecklist: BatteryChecklistItem[],
): ChecklistDisplayItem[] {
  return backendChecklist.map((item) => {
    const completed = item.expected === item.actual;
    const manufacturerLabel = item.label || item.field;
    let label = manufacturerLabel;

    // Format the full sentence based on field type
    if (item.field === "reserve_soc") {
      // Show expected value when not complete, actual value when complete
      const displayValue = completed ? item.actual : item.expected;
      if (typeof displayValue === "number") {
        label = `"${manufacturerLabel}" is set to ${displayValue}%`;
      }
    } else if (item.field === "can_import" || item.field === "can_export") {
      label = `"${manufacturerLabel}" is turned on`;
    } else if (item.field === "is_reachable") {
      label = manufacturerLabel; // No quotes needed for reachability
    }

    return {
      field: item.field,
      label,
      completed,
    };
  });
}
